<div class="col-12">
  <div class="row g-3 align-items-end">
    <div class="col-12">
      <label class="form-label">Usuario existente</label>
      <select
        class="form-select"
        name="usuarioCadastroSelecionado"
        [ngModel]="usuarioSelecionado"
        (ngModelChange)="usuarioSelecionadoChange.emit($event)">
        <option value="">Novo usuario</option>
        <option *ngFor="let item of usuarios" [value]="item.id">{{ item.nome }} - {{ item.email }}</option>
      </select>
    </div>
  </div>
</div>
